export default "__VITE_ASSET__B6r2m3cv__"